import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FieldDataChangedEvent } from "devextreme/ui/form";
import { toPairs } from "lodash-es";
import { ReportDesignItemChecklistRendered } from "src/app/modules/bootstrap/modules/report/report-design-item";
import {
  getCheckListColumns,
  getCheckListGroups,
  getCheckListRows
} from "src/app/modules/bootstrap/modules/report/report-support";
import { tryParseJson } from "src/app/support/json";

@Component({
  selector: "snt-report-form-renderer-checklist",
  templateUrl: "report-form-renderer-checklist.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererChecklistComponent implements OnInit {
  @Input()
  item!: ReportDesignItemChecklistRendered;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readOnly: boolean = false;

  @Output()
  value: EventEmitter<string> = new EventEmitter();

  groups: string[] | undefined;
  columns: string[] | undefined;
  rows: string[] | undefined;

  formData: Record<string, boolean> = {};

  ngOnInit(): void {
    const data = tryParseJson(this.item?.config?.value, {});

    toPairs(data).forEach(([key, value]: [string, unknown]) => {
      this.formData[key] = !!value;
    });

    this.columns = getCheckListColumns(this.item?.config?.columns);
    this.rows = getCheckListRows(this.item?.config?.rows);
    this.groups = getCheckListGroups(this.item?.config?.groups);
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "checklist",
      config: {
        title: this.item.config.title,
        value: this.formData.value
      }
    };
  }

  onFieldDataChanged({ value, dataField }: FieldDataChangedEvent): void {
    this.item.value = JSON.stringify(this.formData);

    this.value.emit(value);
  }
}
